import { Phone, Package, Truck, Award, ChartSpline, TruckIcon, Refrigerator } from 'lucide-react';
import Navbar from '../../components/Navbar';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { getUserProfile } from '../../api/userApi';

export default function Profile() {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const data = await getUserProfile()
                setProfile(data.profile);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    if (loading) return <p>Loading...</p>;

    return (
        <div className='bg-gray-50'>
            <Navbar />

            <div className='flex'>
                {/* Left Navigation */}
                <div className="w-64 bg-white min-h-screen shadow-sm p-6">
                    <nav className="space-y-2">
                        <Link to="/routes" className="shadow-lg flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
                            <TruckIcon className="w-5 h-5" />
                            <span className="font-medium">Routes</span>
                        </Link>
                        <Link to="/refrigerators" className="shadow-lg flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
                            <Refrigerator className="w-5 h-5" />
                            <span className="font-medium">Refrigerators</span>
                        </Link>
                        <Link to="/reports" className="shadow-lg flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
                            <ChartSpline className="w-5 h-5" />
                            <span className="font-medium">Reports</span>
                        </Link>
                    </nav>
                </div>

                {/* Main Content */}
                <div className="w-full p-8">
                    {/* Profile Card - Smaller */}
                    <div className="bg-white rounded-xl shadow-md p-6 mb-6">
                        <div className="flex items-center gap-6">

                            {/* Name & Phone */}
                            <div className="flex-1">
                                <h1 className="text-2xl font-bold text-gray-800 mb-1">#{profile?.country_code} {profile?.mobile_number}</h1>
                                
                            </div>
                        </div>
                    </div>

                    {/* Stats Grid */}
                    {/* <div className="grid grid-cols-3 gap-6 mb-6">
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center gap-3 mb-2">
                                <div className="bg-green-100 rounded-lg p-2">
                                    <Package className="w-5 h-5 text-green-600" />
                                </div>
                                <h3 className="font-semibold text-gray-700">Deliveries</h3>
                            </div>
                            <p className="text-3xl font-bold text-gray-800">247</p>
                            <p className="text-sm text-gray-500 mt-1">Total completed</p>
                        </div>

                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center gap-3 mb-2">
                                <div className="bg-blue-100 rounded-lg p-2">
                                    <Truck className="w-5 h-5 text-blue-600" />
                                </div>
                                <h3 className="font-semibold text-gray-700">Active</h3>
                            </div>
                            <p className="text-3xl font-bold text-gray-800">3</p>
                            <p className="text-sm text-gray-500 mt-1">In progress</p>
                        </div>

                        <div className="bg-white rounded-xl shadow-md p-6">
                            <div className="flex items-center gap-3 mb-2">
                                <div className="bg-yellow-100 rounded-lg p-2">
                                    <Award className="w-5 h-5 text-yellow-600" />
                                </div>
                                <h3 className="font-semibold text-gray-700">Rating</h3>
                            </div>
                            <p className="text-3xl font-bold text-gray-800">4.8</p>
                            <p className="text-sm text-gray-500 mt-1">Average score</p>
                        </div>
                    </div> */}


                </div>
            </div>
        </div>
    );
}